// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Billing from "layouts/receitaXdespesa";
import Orcamento from "layouts/orcamento";
import Goals from "layouts/goals";
import DividendosEProventos from "layouts/dividendosEProventos";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import OperationsLayout from "layouts/operations";
import Payment from "layouts/Payment";
import LandingPage from "layouts/landing";
import Settings from "layouts/settings";

// react-router
import { Navigate } from "react-router-dom";

// @mui icons
import Icon from "@mui/material/Icon";
import Posicao from "layouts/posicao";
import Logout from "layouts/authentication/logout";
import RebalancearCarteira from "layouts/rebalancearCarteira";
import PontuarAtivos from "layouts/rebalancearCarteira/alocação/por-ativo/pontuar-ativo/pontuarAtivos";
import Calculadora from "layouts/calculadora/calculadora";
import AskToResetPassword from "layouts/authentication/reset-password";
import ResetPasswordForm from "layouts/authentication/reset-password/reset-pass-form";
import Mercado from "layouts/Mercado";
import {
  APP_BASE_ROUTE,
  APP_BUDGET_ROUTE,
  APP_CALCULATOR_ROUTE,
  APP_CHECKOUT_ROUTE,
  APP_DASHBOARD_ROUTE,
  APP_DIVIDENDS_ROUTE,
  APP_GOALS_ROUTE,
  APP_MARKET_ROUTE,
  APP_OPERATION_EXTRACT_ROUTE,
  APP_OPERATION_ROUTE,
  APP_PAYMENT_ROUTE,
  APP_POSITION_ROUTE,
  APP_REBALANCE_ROUTE,
  APP_REBALANCE_SCORE_ROUTE,
  APP_REVENUE_EXPENSES_ROUTE,
  APP_SETTINGS_ROUTE,
  LANDING_ROUTE,
  LEGACY_APP_DASHBOARD_ROUTE,
  LEGACY_BUDGET_ROUTE,
  LEGACY_CALCULATOR_ROUTE,
  LEGACY_CHECKOUT_ROUTE,
  LEGACY_DASHBOARD_ROUTE,
  LEGACY_DIVIDENDS_ROUTE,
  LEGACY_GOALS_ROUTE,
  LEGACY_LOGOUT_ROUTE,
  LEGACY_MARKET_ROUTE,
  LEGACY_OPERATION_EXTRACT_ROUTE,
  LEGACY_OPERATION_ROUTE,
  LEGACY_PAYMENT_ROUTE,
  LEGACY_POSITION_ROUTE,
  LEGACY_REBALANCE_ROUTE,
  LEGACY_REBALANCE_SCORE_ROUTE,
  LEGACY_RESET_PASSWORD_FORM_ROUTE,
  LEGACY_RESET_PASSWORD_ROUTE,
  LEGACY_REVENUE_EXPENSES_ROUTE,
  LEGACY_SIGN_IN_ROUTE,
  LEGACY_SIGN_UP_ROUTE,
  LOGOUT_ROUTE,
  RESET_PASSWORD_FORM_ROUTE,
  RESET_PASSWORD_ROUTE,
  SIGN_IN_ROUTE,
  SIGN_UP_ROUTE,
} from "utils/routes";

const routes = [
  {
    name: "Início",
    key: "landing",
    route: LANDING_ROUTE,
    component: <LandingPage />,
    hideSideMenu: true,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: APP_DASHBOARD_ROUTE,
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Receita x Despesa",
    key: "receitaxdespesa",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: APP_REVENUE_EXPENSES_ROUTE,
    component: <Billing />,
  },
  {
    type: "collapse",
    name: "Orçamento",
    key: "orcamento",
    icon: <Icon fontSize="small">savings</Icon>,
    route: APP_BUDGET_ROUTE,
    component: <Orcamento />,
  },
  {
    type: "collapse",
    name: "Metas",
    key: "metas",
    icon: <Icon fontSize="small">flag</Icon>,
    route: APP_GOALS_ROUTE,
    component: <Goals />,
  },
  {
    type: "collapse",
    name: "Operações",
    key: "operation",
    icon: <Icon fontSize="small">swap_horiz</Icon>,
    route: APP_OPERATION_ROUTE,
    component: <OperationsLayout />,
  },
  {
    // type: "collapse", isso fa com que nao apareça no menu lateral
    name: "Dividendos e Proventos",
    key: "dividendos",
    icon: <Icon fontSize="small">paid</Icon>,
    route: APP_DIVIDENDS_ROUTE,
    component: <DividendosEProventos />,
  },
  {
    name: "Posição",
    key: "renda_variavel_grafico",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: APP_POSITION_ROUTE,
    component: <Posicao />,
  },
  {
    type: "collapse",
    name: "Rebalancear carteira",
    key: "rebalancear",
    icon: <Icon fontSize="small">currency_exchange</Icon>,
    route: APP_REBALANCE_ROUTE,
    component: <RebalancearCarteira />,
    isPro: true,
  },
  {
    type: "collapse",
    name: "Simulador de alocação",
    key: "calculadora",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: APP_CALCULATOR_ROUTE,
    component: <Calculadora />,
    isPro: true,
  },
  {
    name: "Checkout",
    key: "checkout",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: APP_CHECKOUT_ROUTE,
    component: <Payment />,
    hideSideMenu: true,
  },
  {
    name: "Pagamento",
    key: "pagamento-app",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: APP_PAYMENT_ROUTE,
    component: <Navigate to={APP_CHECKOUT_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    type: "collapse",
    name: "Mercado",
    key: "mercado",
    icon: <Icon fontSize="small">candlestick_chart</Icon>,
    route: APP_MARKET_ROUTE,
    component: <Mercado />,
  },
  {
    name: "Configurações",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: APP_SETTINGS_ROUTE,
    component: <Settings />,
    requiresAuth: true,
  },
  {
    name: "Entrar",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: SIGN_IN_ROUTE,
    component: <SignIn />,
    hideSideMenu: true,
  },
  {
    name: "Criar conta",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: SIGN_UP_ROUTE,
    component: <SignUp />,
    hideSideMenu: true,
  },
  {
    name: "Sair",
    key: "logout",
    route: LOGOUT_ROUTE,
    component: <Logout />,
    hideSideMenu: true,
  },
  {
    name: "Extrato",
    key: "extrato",
    route: APP_OPERATION_EXTRACT_ROUTE,
    component: <OperationsLayout />,
  },
  {
    name: "Peso por ativo",
    key: "pontuar-ativos",
    route: APP_REBALANCE_SCORE_ROUTE,
    component: <PontuarAtivos />,
  },
  {
    name: "Esqueci minha senha",
    key: "reset-password",
    icon: <Icon fontSize="small">login</Icon>,
    route: RESET_PASSWORD_ROUTE,
    component: <AskToResetPassword />,
    hideSideMenu: true,
  },
  {
    name: "Redefinir senha",
    key: "reset-password-form",
    icon: <Icon fontSize="small">login</Icon>,
    route: RESET_PASSWORD_FORM_ROUTE,
    component: <ResetPasswordForm />,
    hideSideMenu: true,
  },
  {
    key: "legacy-app-dashboard",
    route: LEGACY_APP_DASHBOARD_ROUTE,
    component: <Navigate to={APP_BASE_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-dashboard",
    route: LEGACY_DASHBOARD_ROUTE,
    component: <Navigate to={APP_DASHBOARD_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-receita-x-despesa",
    route: LEGACY_REVENUE_EXPENSES_ROUTE,
    component: <Navigate to={APP_REVENUE_EXPENSES_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-orcamento",
    route: LEGACY_BUDGET_ROUTE,
    component: <Navigate to={APP_BUDGET_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-metas",
    route: LEGACY_GOALS_ROUTE,
    component: <Navigate to={APP_GOALS_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-operation",
    route: LEGACY_OPERATION_ROUTE,
    component: <Navigate to={APP_OPERATION_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-operation-extract",
    route: LEGACY_OPERATION_EXTRACT_ROUTE,
    component: <Navigate to={APP_OPERATION_EXTRACT_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-dividendos",
    route: LEGACY_DIVIDENDS_ROUTE,
    component: <Navigate to={APP_DIVIDENDS_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-posicao",
    route: LEGACY_POSITION_ROUTE,
    component: <Navigate to={APP_POSITION_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-rebalancear",
    route: LEGACY_REBALANCE_ROUTE,
    component: <Navigate to={APP_REBALANCE_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-rebalancear-pontuar",
    route: LEGACY_REBALANCE_SCORE_ROUTE,
    component: <Navigate to={APP_REBALANCE_SCORE_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-calculadora",
    route: LEGACY_CALCULATOR_ROUTE,
    component: <Navigate to={APP_CALCULATOR_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-checkout",
    route: LEGACY_CHECKOUT_ROUTE,
    component: <Navigate to={APP_CHECKOUT_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-pagamento",
    route: LEGACY_PAYMENT_ROUTE,
    component: <Navigate to={APP_CHECKOUT_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-mercado",
    route: LEGACY_MARKET_ROUTE,
    component: <Navigate to={APP_MARKET_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-sign-in",
    route: LEGACY_SIGN_IN_ROUTE,
    component: <Navigate to={SIGN_IN_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-sign-up",
    route: LEGACY_SIGN_UP_ROUTE,
    component: <Navigate to={SIGN_UP_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-logout",
    route: LEGACY_LOGOUT_ROUTE,
    component: <Navigate to={LOGOUT_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-reset-password",
    route: LEGACY_RESET_PASSWORD_ROUTE,
    component: <Navigate to={RESET_PASSWORD_ROUTE} replace />,
    hideSideMenu: true,
  },
  {
    key: "legacy-reset-password-form",
    route: LEGACY_RESET_PASSWORD_FORM_ROUTE,
    component: <Navigate to={RESET_PASSWORD_FORM_ROUTE} replace />,
    hideSideMenu: true,
  },
];

export default routes;
